export default __webpack_public_path__ + "static/media/course2.fb7d111e.webp";